module.exports = __webpack_public_path__ + "img/home-eclectic-bedroom.87e9db41.jpg";